import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const SellerAuthContext = createContext(null);

const API_URL = process.env.REACT_APP_API_URL || '/api';

export const SellerAuthProvider = ({ children }) => {
  const [seller, setSeller] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('sellerToken'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      fetchSeller();
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchSeller = async () => {
    try {
      const response = await axios.get(`${API_URL}/seller/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSeller(response.data.seller);
    } catch (error) {
      console.error('Failed to fetch seller:', error);
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const response = await axios.post(`${API_URL}/seller/login`, { email, password });
    const { token: newToken, seller: sellerData } = response.data;
    localStorage.setItem('sellerToken', newToken);
    setToken(newToken);
    setSeller(sellerData);
    return sellerData;
  };

  // MSG91 widget path. A brand-new seller comes back with profile_complete
  // false and gets sent to finish their details.
  const loginWithAccessToken = async (accessToken) => {
    const response = await axios.post(`${API_URL}/seller/otp-login`, { accessToken });
    const { token: newToken, seller: sellerData } = response.data;
    localStorage.setItem('sellerToken', newToken);
    setToken(newToken);
    setSeller(sellerData);
    return sellerData;
  };

  const register = async (name, phone, email, password) => {
    const response = await axios.post(`${API_URL}/seller/register`, { name, phone, email, password });
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem('sellerToken');
    setToken(null);
    setSeller(null);
  };

  const getAuthHeader = () => {
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  const refreshSeller = fetchSeller;

  return (
    <SellerAuthContext.Provider value={{ seller, token, login, loginWithAccessToken, register, logout, loading, getAuthHeader, API_URL, refreshSeller }}>
      {children}
    </SellerAuthContext.Provider>
  );
};

export const useSellerAuth = () => {
  const context = useContext(SellerAuthContext);
  if (!context) {
    throw new Error('useSellerAuth must be used within SellerAuthProvider');
  }
  return context;
};
